import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { message } from 'antd';
import './index.scss';
import 'material-design-iconic-font/dist/css/material-design-iconic-font.min.css';
import 'react-datetime/css/react-datetime.css';

const _message_error = message.error;

message.error = msg => {
    if (msg) {
        _message_error(msg);
    }
};

ReactDOM.render(<App />, document.getElementById('root'));

